module.exports = __webpack_public_path__ + "static/icomoon.e91be601.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.woff
// module id = 322
// module chunks = 114276838955818